const spotlightImage = (name) =>
    require("@/assets/image/exhibitor-spotlight/" + name);

const sortNewsByDateDesc = (left, right) =>
    right.date.localeCompare(left.date);

export const EXHIBITOR_SPOTLIGHT_NEWS = [
    {
        id: "cscec-third-bureau",
        title: "2026江苏绿色低碳建筑国际博览会展商|中建八局第三建设有限公司",
        date: "2026-01-30",
        displayDate: "2026年1月30日",
        blocks: [
            { type: "logo", src: spotlightImage("zs_1_1.png"), alt: "中建八局第三建设有限公司" },
            { type: "paragraph", text: "中建八局第三建设有限公司，隶属于中国建筑股份有限公司，1983年在南京由基建工程兵集体转业改编，2007年整体改制为现单位。公司拥有房屋建筑工程施工总承包特级资质和建筑行业工程设计甲级资质，以及市政工程、机电工程施工总承包壹级资质以及多项专业承包壹级资质。先后被评为创鲁班奖工程特别荣誉企业、全国建筑业竞争力百强企业、全国优秀施工企业、全国建筑业AAA级信用企业、江苏省安全生产先进单位、江苏省科技进步和技术创新先进单位等。" },
            { type: "section-heading", text: "主要展品" },
            { type: "product-heading", text: "“天蝉”TC-PC1.0施工机器人系统" },
            { type: "image-group", images: [{ src: spotlightImage("zs_1_3.png"), alt: "天蝉TC-PC1.0施工机器人系统" }] },
            { type: "paragraph", text: "“天蝉”TC-PC1.0施工机器人系统由钢平台及支撑系统、挂架及防护系统、顶升系统、分布式智能施工系统、智能控制系统五大系统组成，悬挂式智能施工装备涵盖吊装、整平、振捣、覆膜等主要工序。该系统软硬件均具备可扩展性，可根据需求自由增减施工装备种类和数量，已打通装配式住宅混凝土施工场景主要工序的装备化作业链条，特别适用于100米以下的装配式住宅项目。" },
            { type: "product-heading", text: "“S-D-S”三元体系低碳胶凝材料" },
            { type: "paragraph", text: "“S-D-S”三元体系低碳胶凝材料是以工业固废（矿粉、钢渣、脱硫灰）为主材，通过粉磨加复配的工艺制备。经材料配合比调整，可实现50%至100%的取代水泥进行部分工程部位施工。该材料与土壤结合性能好，水化热低，生产碳排放低。" },
            { type: "product-heading", text: "建筑运维系统" },
            { type: "image-group", images: [{ src: spotlightImage("zs_1_2.png"), alt: "建筑运维系统" }] },
            { type: "paragraph", text: "基于BIM的智慧运维管理平台，面向现代建筑后勤管理安全要求高、管理难度大等痛点，以数字孪生为基础，覆盖医院、学校、场馆、园区、社区等全业务场景，实现建筑楼宇安全智能诊断分析与运维可视化管理，保障建筑更加安全、节能、高效运行。" },
            { type: "section-heading", text: "同期活动" },
            { type: "paragraph", text: "展会同期将举办“天蝉”TC-PC技术产业创新交流会，邀请主管部门、行业协会、高校、相关企业等代表，介绍产品核心技术、创新点、工程应用成效、行业推广价值，同时还将举办有关合作签约仪式。" },
            { type: "section-heading", text: "目标观众" },
            { type: "paragraph", text: "我们诚邀房地产开发企业、建筑设计院所、高校科研机构、智能建造及绿色建材上下游企业、物业运维单位、行业协会等莅临参观。如您希望进行展前贸易对接，请发送您的需求至邮箱：gbie@gbservice.cn，我们将第一时间与您联系。" },
        ],
    },
    {
        id: "otis-china",
        title: "2026江苏绿色低碳建筑国际博览会展商|奥的斯电梯（中国）有限公司",
        date: "2026-03-13",
        displayDate: "2026年3月13日",
        blocks: [
            { type: "logo", src: spotlightImage("zs_2-1.png"), alt: "奥的斯电梯（中国）有限公司" },
            { type: "paragraph", text: "奥的斯是全球知名的电梯和自动扶梯制造商、安装和服务提供商，连续蝉联全球电梯制造商十强榜首。作为最早进入中国市场的电梯公司之一，奥的斯在华深耕40余载，始终坚持“扎根中国，服务世界”，助力中国城市高质量发展，为众多地标建筑、基础设施及住宅等项目提供电扶梯产品、服务及现代化更新解决方案，并持续响应国家号召，助力城市更新和老旧电梯更新民生工程。" },
            { type: "section-heading", text: "主要展品" },
            { type: "product-heading", text: "奥的斯Gen3 Comfort智能电梯" },
            { type: "image-group", images: [{ src: spotlightImage("zs_2-2.jpg"), alt: "奥的斯Gen3 Comfort智能电梯" }] },
            { type: "paragraph", text: "奥的斯Gen3 Comfort智能电梯以好房子“安全、舒适、绿色、智慧”为标准，专为住宅焕新设计，融入无障碍设计、适老化关怀及儿童宠物友好理念，打造适配好房子的理想“好电梯”。" },
            { type: "product-heading", text: "奥的斯万能门机" },
            { type: "image-group", images: [{ src: spotlightImage("zs_2-3.jpg"), alt: "奥的斯万能门机" }] },
            { type: "paragraph", text: "奥的斯万能门机全系适配，覆盖所有电梯型号，稳定兼容，即装即用，满足老旧电梯更新改造需求。行业领先的IP65门机防护等级，防止粉尘进入，任何角度低压喷射无影响，运行安全可靠。" },
            { type: "product-heading", text: "奥的斯ReGen能源再生变频技术" },
            { type: "image-group", images: [{ src: spotlightImage("zs_2-4.png"), alt: "奥的斯ReGen能源再生变频技术" }] },
            { type: "paragraph", text: "奥的斯ReGen能源再生变频技术能够将电梯运行过程中产生的势能转化为清洁能源，并回馈至建筑物电力系统中，实现能源循环利用。与未采用此技术的常规驱动系统相比，最多可减少约75%的电耗。" },
            { type: "section-heading", text: "同期活动" },
            { type: "paragraph", text: "同期将举办奥的斯现代化更新研讨交流活动，聚焦“好房子”理念下如何打造“好电梯、好方案”，分享奥的斯在电梯更新改造领域的创新解决方案及领先优势，持续助力城市更新。" },
            { type: "section-heading", text: "目标客户" },
            { type: "paragraph", text: "奥的斯提供覆盖电梯研发、制造、安装、维保、现代化更新的全生命周期管理，面向有电梯更新改造、电梯设备采购、电梯维修维保服务等需求的政企和个人，提供绿色、低碳、智能、安全的电梯产品与服务。如您希望进行展前贸易对接，请发送您的需求至邮箱：gbie@gbservice.cn。" },
        ],
    },
    {
        id: "huawei",
        title: "2026江苏绿色低碳建筑国际博览会展商|华为技术有限公司",
        date: "2026-03-13",
        displayDate: "2026年3月13日",
        blocks: [
            { type: "logo", src: spotlightImage("640 (1).png"), alt: "华为技术有限公司" },
            { type: "paragraph", text: "华为是全球领先的ICT基础设施和智能终端提供商，愿景与使命是把数字世界带入每个人、每个家庭、每个组织，构建万物互联的智能世界。华为聚焦ICT技术，面向消费者、运营商客户、政企三类客户，携手生态及伙伴提供产品解决方案和服务。" },
            { type: "section-heading", text: "主要展品" },
            { type: "product-heading", text: "华为鸿蒙智家解决方案" },
            { type: "paragraph", text: "以智能主机作为全屋的智慧大脑，基于PLC、Wi-Fi、蓝牙、星闪等稳定连接方式，连接全屋智能设备，实现对照明、遮阳、冷暖新风、安防、网络、用水、影音娱乐、能耗、家电、家具家私等子系统的统一掌控，打造可成长、可适配、低碳化的全场景人车家智慧生活体验。" },
            { type: "product-heading", text: "问界M9" },
            { type: "paragraph", text: "华为与赛力斯联合打造的新能源高端旗舰SUV，搭载华为全栈智能技术，提供增程、纯电两种动力，配备零重力座椅等豪华配置，兼顾家庭出行与商务接待，是兼具智能、舒适与实用性的全景智慧旗舰SUV。" },
            { type: "product-heading", text: "Mate80系列" },
            { type: "paragraph", text: "Mate80系列是2026年春晚首个且唯一手机直播用机，采用业界首创的双环设计与全金属设计，兼具精致性与可靠性。" },
            { type: "section-heading", text: "同期活动" },
            { type: "paragraph", text: "聚焦人工智能加住房城乡建设、绿色智慧人居、智能建造产业发展核心方向，打造“未来家，AI生活”专业技术交流，邀请房地产、建筑、家装企业合作伙伴分享落地案例。" },
            { type: "section-heading", text: "目标观众" },
            { type: "paragraph", text: "我们诚邀房地产开发商、酒店运营方、康养公司、集成商、家装行业等莅临参观。如您希望进行展前贸易对接，请发送您的需求至邮箱：gbie@gbservice.cn，我们将第一时间与您联系。" },
        ],
    },
    {
        id: "nippon-paint",
        title: "2026江苏绿色低碳建筑国际博览会展商|立邦涂料（中国）有限公司",
        date: "2026-03-13",
        displayDate: "2026年3月13日",
        blocks: [
            { type: "logo", src: spotlightImage("zs_4_1.png"), alt: "立邦涂料（中国）有限公司" },
            { type: "paragraph", text: "立时集团于1962年创立于新加坡，1992年进入中国并取名“立邦”，总部位于上海，拥有70余家生产基地和近1.1万名员工。秉持“刷新美好生活空间”的使命，立邦业务覆盖建筑与工业领域，在建筑工程领域致力于用科技构建客户首选的全场景涂装集成方案专业服务平台，服务于鸟巢、大兴机场等国家级重点项目。" },
            { type: "section-heading", text: "主要展品" },
            { type: "product-heading", text: "立邦“好房子”场景解决方案" },
            { type: "image-group", images: [{ src: spotlightImage("zs_4_2.jpg"), alt: "立邦好房子场景解决方案" }] },
            { type: "paragraph", text: "该方案覆盖外墙、地下车库、既有建筑更新改造、绿色环保室内装饰装修、不漏不渗屋面、全龄友好社区场地等场景。其中隔声保温地坪涂装体系可有效降低噪音20至30分贝，Ufast快涂优楼道翻新方案则可大幅提升改造效率，减少对居民正常生活的影响。" },
            { type: "product-heading", text: "立邦优能辐射致冷涂料" },
            { type: "image-group", images: [{ src: spotlightImage("zs_4_3.jpg"), alt: "立邦优能辐射致冷涂料" }] },
            { type: "paragraph", text: "优能辐射致冷涂料通过“高效隔热”与“主动散热”双重机制实现被动降温。实测显示，涂刷后屋顶外表面温度可下降20摄氏度，室内体感温度较普通涂料降低6摄氏度，可有效解决工业厂房物料变质与人员舒适度问题，助力企业绿色转型与双碳目标落地。" },
            { type: "section-heading", text: "同期活动" },
            { type: "paragraph", text: "同期将举办“好房子”建设及更新涂装技术解决方案发布活动，聚焦地域特色发布专项技术解决方案，汇聚行业专家与相关领导，共话“好房子”建设路径，搭建政企对接与行业交流平台。" },
            { type: "section-heading", text: "目标客户" },
            { type: "paragraph", text: "我们诚邀学校、医院、保障房、市政、公建单位，以及既有建筑节能改造、翻新、维保项目的节能服务商、物业公司、各类开发企业、总承包单位等莅临参观。如您希望进行展前贸易对接，请发送您的需求至邮箱：gbie@gbservice.cn。" },
        ],
    },
    {
        id: "jibs",
        title: "2026江苏绿色低碳建筑国际博览会展商|江苏省建筑科学研究院有限公司",
        date: "2026-03-13",
        displayDate: "2026年3月13日",
        blocks: [
            { type: "logo", src: spotlightImage("zs_5_1.png"), alt: "江苏省建筑科学研究院有限公司" },
            { type: "paragraph", text: "江苏省建筑科学研究院有限公司成立于1958年，是国内建设行业规模较大、产业化程度较高的综合性科学研究和技术开发机构。拥有控股子公司9家，形成新材料、工程咨询和特种施工三大主业，业务遍及全国30多个省、自治区、直辖市及海外。" },
            { type: "paragraph", text: "公司员工6000余人，拥有包括中国工程院院士、国务院政府特殊津贴专家等高层次人才在内的专业团队，建设并运行全国重点实验室、国家检测检验中心等科研平台，累计获得1100余件国家发明专利及40余项科技进步奖，成果广泛应用于长江三峡、京沪高铁、港珠澳大桥、川藏铁路等国家重点工程。" },
            { type: "section-heading", text: "主要展品" },
            { type: "product-heading", text: "超高性能混凝土（UHPC）" },
            { type: "image-group", images: [{ src: spotlightImage("zs_5_2.jpg"), alt: "超高性能混凝土" }] },
            { type: "paragraph", text: "超高性能混凝土具有极高强度、韧性和耐久性。公司突破混凝土超高强度、超高韧性和超高抗力技术瓶颈，发明了常规浇筑和养护条件下抗压强度大于200MPa的超高性能混凝土材料，成果已应用于南京长江五桥、上海松浦大桥、宁波西洪大桥等项目。" },
            { type: "product-heading", text: "AIBMS低碳智慧建筑运维管理系统" },
            { type: "paragraph", text: "系统以AI、BIM、IoT等技术为支撑，集成楼宇各类设备和传感器，实现建筑空间、设施设备、环境健康、人员行为、能碳监测的智慧运营管理。系统以数字孪生为底座、大模型为大脑、智能体为手脚，构建贯穿“感知、分析、决策、执行、反馈”的建筑运维智能体，并深度集成“光储直柔”新型微电网架构。" },
            { type: "product-heading", text: "建筑低碳运行智能诊断测试系统" },
            { type: "image-group", images: [{ src: spotlightImage("zs_5_3.jpg"), alt: "建筑低碳运行智能诊断测试系统一" }, { src: spotlightImage("zs_5_4.jpg"), alt: "建筑低碳运行智能诊断测试系统二" }] },
            { type: "paragraph", text: "系统集成温度、热流、风速、电能、流量等多维度检测与诊断模块，可根据项目需求灵活组合测试方案。系统内置标准化计算与AI优化功能，支持自主编制算法，一套系统可衍生多种测试方案，大幅降低采购成本、提升检测效率。" },
            { type: "section-heading", text: "目标客户" },
            { type: "paragraph", text: "我们可提供绿色低碳建筑技术、材料、咨询及智慧运维整体解决方案，诚邀各地市建设主管部门、各级城投公司、房地产开发商、建材企业及建筑施工、设计、运营相关单位等莅临参观。如您希望进行展前贸易对接，请发送您的需求至邮箱：gbie@gbservice.cn。" },
        ],
    },
    {
        id: "lazzen",
        title: "2026江苏绿色低碳建筑国际博览会展商|上海良信电器股份有限公司",
        date: "2026-03-13",
        displayDate: "2026年3月13日",
        blocks: [
            { type: "logo", src: spotlightImage("zs_6_1.png"), alt: "上海良信电器股份有限公司" },
            { type: "paragraph", text: "LAZZEN良信成立于1999年，定位于“智慧低压电气解决方案专家”，专注终端电器、配电电器、控制电器、智能配电、智慧人居等领域的研发、生产、销售和服务，产品及解决方案广泛应用于发电端、输配电、用电端各场景，业务覆盖信息通讯、新能源、建筑等多个领域。" },
            { type: "paragraph", text: "良信始终坚持“成就客户”的核心价值观，以客户需求驱动产品研发，研发中心被认定为“国家企业技术中心”，并设立“企业博士后科研工作站”。目前国内办事区域覆盖140多个重点城市，为全球30多个国家和地区的客户提供专业而高效的服务。" },
            { type: "section-heading", text: "主要展品" },
            { type: "paragraph", text: "良信聚焦四大核心创新成果，以“技术重构居住体验，科技赋能绿色生活”为理念，全方位呈现从家庭智能控制到能源高效管理的全链条解决方案。" },
            { type: "product-heading", text: "天启数字家庭综合箱" },
            { type: "image-group", images: [{ src: spotlightImage("zs_6_2.png"), alt: "天启数字家庭综合箱" }] },
            { type: "paragraph", text: "天启数字家庭综合箱以“化零为整”的创新思维，凭借全球首创的强弱电一体化数字技术，重新定义“好房子”的智能标准。该产品累计申请专利111项，将艺术审美与用电科技深度融合，让住宅成为集安全、舒适、绿色、智慧于一体的生活载体。" },
            { type: "product-heading", text: "LCB插拔式断路器" },
            { type: "image-group", images: [{ src: spotlightImage("zs_6_3.png"), alt: "LCB插拔式断路器" }] },
            { type: "paragraph", text: "LCB插拔式断路器以18毫米超薄尺寸实现漏电自检、远程控制、电能检测三大核心功能，凭借模块化颠覆设计，树立行业高效运维新标杆。" },
            { type: "product-heading", text: "户储解决方案" },
            { type: "image-group", images: [{ src: spotlightImage("zs_6_4.png"), alt: "户储解决方案" }] },
            { type: "paragraph", text: "围绕建筑光伏一体化与车储充场景一体化，为全球家庭提供全链路绿色能源管理方案。" },
            { type: "product-heading", text: "智能配电系统" },
            { type: "image-group", images: [{ src: spotlightImage("zs_6_5.png"), alt: "智能配电系统" }] },
            { type: "paragraph", text: "良信智能配电系统以技术突破实现合资替代，为企业园区零碳战略落地提供坚实支撑。" },
            { type: "section-heading", text: "目标客户" },
            { type: "paragraph", text: "我们诚邀各地市建设主管部门、各级城投公司、房地产开发商及上下游产业链相关合作伙伴莅临参观。如您希望进行展前贸易对接，请发送您的需求至邮箱：gbie@gbservice.cn。" },
        ],
    },
    {
        id: "urban-water-monitoring",
        title: "2026江苏绿色低碳建筑国际博览会展商|江苏城镇给排水监测有限公司",
        date: "2026-03-13",
        displayDate: "2026年3月13日",
        blocks: [
            { type: "logo", src: spotlightImage("zs_7_1.jpg"), alt: "江苏城镇给排水监测有限公司" },
            { type: "paragraph", text: "江苏城镇给排水监测有限公司暨国家城市供水水质监测网南京监测站，是江苏省内唯一具备国家实验室认可（CNAS）与资质认定（CMA）双认证，能够对社会出具证明作用、具有公正性检测报告的实验室。业务覆盖检验检测服务、环境保护监测、技术研发推广、竞赛培训等多个领域。" },
            { type: "section-heading", text: "主要展品" },
            { type: "product-heading", text: "全流程智慧化实验室场景" },
            { type: "image-group", images: [{ src: spotlightImage("zs_7_2.png"), alt: "全流程智慧化实验室场景" }] },
            { type: "paragraph", text: "实验室汇聚国内顶尖机器人技术、无人采样、智能检测装备与5G算法优势，构建集智能感知、自动分析、精准研判、主动预警于一体的现代化监测体系，可按需提供个性化智能解决方案，打造全链条、一体化的集成服务。" },
            { type: "product-heading", text: "机械臂" },
            { type: "image-group", images: [{ src: spotlightImage("zs_7_3.jpg"), alt: "机械臂" }] },
            { type: "paragraph", text: "机械臂集成全自动样品抓取、瓶盖旋拧、自动取水等一体化作业功能，全程无需人工干预，可直接替代传统人工操作，大幅提升作业效率与稳定性。" },
            { type: "product-heading", text: "无人采样车" },
            { type: "image-group", images: [{ src: spotlightImage("zs_7_4.jpg"), alt: "无人采样车" }] },
            { type: "paragraph", text: "无人采样车可代替人工取水工作，具备多场景、全天候完全自动驾驶能力，室内、窄路均可灵活通行，可实现随时待命、远程指挥取水功能，提高应急能力。" },
            { type: "section-heading", text: "目标客户" },
            { type: "paragraph", text: "水务行业内有实验室新建、升级及改造需求的大中小企业，以及其他行业配备各类实验室、有相关需求的单位。如您希望进行展前贸易对接，请发送您的需求至邮箱：gbie@gbservice.cn。" },
        ],
    },
    {
        id: "jsurcc",
        title: "2026江苏绿色低碳建筑国际博览会展商|江苏城乡建设职业学院",
        date: "2026-03-13",
        displayDate: "2026年3月13日",
        blocks: [
            { type: "logo", src: spotlightImage("zs_8_1.png"), alt: "江苏城乡建设职业学院" },
            { type: "paragraph", text: "江苏城乡建设职业学院隶属于省住建厅，始建于1986年，位于江苏常州，是省属公办高职、江苏省中国特色高水平高职学校。学校致力于绿色低碳建筑关键技术、智能建造、新型建筑工业化等领域教学与技术研发，拥有世界技能大赛中国集训基地，先后获评国家技能人才培育突出贡献单位、全国绿色低碳公共机构、全国健康学校建设单位等荣誉。" },
            { type: "section-heading", text: "主要展品" },
            { type: "paragraph", text: "展区主要设置学校荣誉、师德典范、技能闪耀、产教融合、社会服务等版块，展示学校在办学特色、人才培养与社会服务等方面的突出成果。现场布置中式花艺、木工技艺、彩绘面塑三个主题互动区域，同步展示师生作品。" },
            { type: "product-heading", text: "师生中式花艺作品展示" },
            { type: "image-group", images: [{ src: spotlightImage("zs_8_2.png"), alt: "师生中式花艺作品展示一" }, { src: spotlightImage("zs_8_3.png"), alt: "师生中式花艺作品展示二" }] },
            { type: "paragraph", text: "以“花艺互动交流，品创造之美”为主题，由花艺大师李昌贤与在校学生现场展示插花艺术，同时设置体验区，邀请观众参与捧花、盆栽、胸花等不同类型的项目体验，感受传统技艺的创造之美。" },
            { type: "product-heading", text: "师生木工技艺作品展示" },
            { type: "image-group", images: [{ src: spotlightImage("zs_8_4.png"), alt: "师生木工技艺作品展示一" }, { src: spotlightImage("zs_8_5.png"), alt: "师生木工技艺作品展示二" }] },
            { type: "paragraph", text: "以“木作技艺展示互动，传匠心之韵”为主题，由全国技术能手郭雨婷与在校学生现场展示传统木作技艺，通过现场制作书签、冰箱贴等趣味小物件，让观众体验榫卯拼装、雕刻技法等。" },
            { type: "product-heading", text: "师生彩绘面塑作品展示" },
            { type: "image-group", images: [{ src: spotlightImage("zs_8_6.png"), alt: "师生彩绘面塑作品展示" }] },
            { type: "paragraph", text: "以“彩绘泥塑工艺展示，续文化之脉”为主题，由建筑艺术学院陈爽老师与在校学生现场展示传统彩绘面塑技艺，现场制作具有中国传统特色、学校特色的小型面塑作品，供观众观赏与互动。" },
            { type: "section-heading", text: "目标客户" },
            { type: "paragraph", text: "主要面向建筑行业相关企业单位以及有升学需求的家长学生等，旨在展示学校各方面育人成效和办学成效。如您希望进行展前对接，请发送您的需求至邮箱：gbie@gbservice.cn，我们将第一时间与您联系。" },
        ],
    },
].sort(sortNewsByDateDesc);

export function findExhibitorSpotlightById(id) {
    return EXHIBITOR_SPOTLIGHT_NEWS.find((item) => item.id === id) || null;
}
